/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { productSelectorStyles } from "@monsma/Overrides/Components/ProductSelector";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

productSelectorStyles.container = {
    gap: 30,
};

productSelectorStyles.searchGridItem = {
    width: [12, 12, 4, 5, 5],
    css: css`
        &&& {
            max-width: 262px;

            ${screen("lte", "sm")} {
                max-width: 100%;
            }
        }
    `,
};

productSelectorStyles.qtyGridItem = {
    width: [5, 3, 2, 2, 2],
};

productSelectorStyles.unitOfMeasureGridItem = {
    width: [7, 9, 3, 2, 2],
};

productSelectorStyles.selectButton = {
    css: css`
        margin: 0;
        margin-top: 24px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        width: 100%;
                        margin: 0;
                    `,
                ],
                "max",
            )}
    `,
};
